import { TEMPLATE_TYPES } from "utils/constants";
import B2C_COLLECTIVE_AMELLIS from "./Amellis";
import B2C_COLLECTIVE_WITH_PRICE_AMELLIS from "./AmellisWithPrice";

const Templates = {
  [TEMPLATE_TYPES.B2C_COLLECTIVE_AMELLIS]: B2C_COLLECTIVE_AMELLIS,
  [TEMPLATE_TYPES.B2C_COLLECTIVE_WITH_PRICE_AMELLIS]:
    B2C_COLLECTIVE_WITH_PRICE_AMELLIS,
};
export default Templates;
